import script from "./newsInfoList.vue?vue&type=script&setup=true&lang=js"
export * from "./newsInfoList.vue?vue&type=script&setup=true&lang=js"

import "./newsInfoList.vue?vue&type=style&index=0&id=f0ede12e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0ede12e"]])

export default __exports__